import * as React from "react";
import * as ReactDOM from "react-dom";
import { OptionalLink } from "../optionalLink";

interface IProperties
{
    /**
     * Anzeige Text.
     */
    text?: string,

    /**
     * Link (react-router).
     */
    linkTo?: string | {},

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (e: MouseEvent) => void
}

export class HeaderBreadcrumbItem extends React.Component<IProperties>
{
    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        this.props.onClick && this.props.onClick(e.nativeEvent);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        return (
            <OptionalLink
                className="header_breadcrumb-item"
                to={this.props.linkTo}
                onClick={this.onClick}>
                {this.props.text}
            </OptionalLink>
        );
    }
}